import { render } from "./SearchGuards.vue?vue&type=template&id=5063b2c5&scoped=true"
import script from "./SearchGuards.vue?vue&type=script&lang=js"
export * from "./SearchGuards.vue?vue&type=script&lang=js"

import "./SearchGuards.vue?vue&type=style&index=0&id=5063b2c5&scoped=true&lang=css"

import exportComponent from "/home/zhenyan/WebstormProjects/live-data-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5063b2c5"]])

export default __exports__